import React from "react";
import RepeatIcon from "../SVG/RepeatIcon";

function Button360({ onClickFn, disabled }) {
  return (
    <button
      className={`group shadow-btnShadow py-3 px-20px rounded hover:outline hover:outline-primary`}
      onClick={onClickFn}
      disabled={disabled}
    >
      <div className="flex justify-center items-center gap-4">
        <RepeatIcon />
        <div className="text-primary">360°</div>
      </div>
    </button>
  );
}

export default Button360;
